<table class="subwindow" [cdkDragConstrainPosition]="constrainPosition" plessTitleWindowSub cdkDrag [windowMovable]="false" [windowResizable]="false">
  <tr class="subwindow-title" cdkDragHandle>
    <th class="window-title-name">ECタイムセールマスタ設定</th>
    <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
  </tr>
  <tr class="subwindow-body">
    <td>
      <div class="contents-area" (dragstart)="onDragstartBody($event)">

        <div class="column-list">
          <label class="list-input-title">受注コード</label>
          <div class="list-input-content">
            <app-order-code-text-input id="txti_OrderCode" #txti_OrderCode
              [subid]="'txti_OrderCode'" [(ngModel)]="kymw6501Model.orderCode" [required]="true"
              [catalogIDField]="lbl_CatalogId" (ngModelChange)="eventOrderCode_CHANGEHandler()" [tabindex]="0">
            </app-order-code-text-input>
          </div>

          <label class="list-input-title">配達企画回（翌週）</label>
          <div class="list-input-content">
            <input type="text" class="deliv-catalog" id="lbl_CatalogId" #lbl_CatalogId readonly>
          </div>

          <label class="list-input-title">カテゴリ</label>
          <div class="list-input-content" style="width: 300px;">
            <app-cws-plan-category-code-combo-box id="cmb_CategoryCode" #cmb_CategoryCode [subid]="'cmb_CategoryCode'"
              [(ngModel)]="kymw6501Model.categoryCode" [required]="true" [categoryLevel]="1" stockLimitFlg="1"
              (change)="eventOrderCode_CHANGEHandler()" [tabindex]="0">
            </app-cws-plan-category-code-combo-box>
          </div>

          <label class="list-input-title">開催期間</label>
          <div class="list-input-content">
            <wj-input-date class="text-label-required" id="dtf_StartDate" #dtf_StartDate [isRequired]="false"
              [(text)]="kymw6501Model.startDateYMD" [tabindex]="0">
            </wj-input-date>
            <select id="cmb_StartHour" labelField="PlanCoopName" 
              class="combo-box-required" #cmb_StartHour [(ngModel)]="kymw6501Model.startDateHH"
              [tabindex]="0">
              <ng-template ngFor let-item [ngForOf]="kymw6501Model.startHourList">
                <option [value]="item">{{item}}</option>
              </ng-template>
            </select>
            <label>時</label>
            <select id="cmb_StartMinute" labelField="PlanCoopName" class="combo-box-required"
              #cmb_StartMinute [(ngModel)]="kymw6501Model.startDateMI" [tabindex]="0">
              <ng-template ngFor let-item [ngForOf]="kymw6501Model.startMinuteList">
                <option [value]="item">{{item}}</option>
              </ng-template>
            </select>
            <label>分</label>
            <label>～</label>
            <wj-input-date class="text-label-required" id="dtf_EndDate" #dtf_EndDate [isRequired]="false"
              [(text)]="kymw6501Model.endDateYMD" [tabindex]="0">
            </wj-input-date>
            <select id="cmb_EndHour" labelField="PlanCoopName" class="combo-box-required" #cmb_EndHour
              [(ngModel)]="kymw6501Model.endDateHH" [tabindex]="0">
              <ng-template ngFor let-item [ngForOf]="kymw6501Model.endHourList">
                <option [value]="item">{{item}}</option>
              </ng-template>
            </select>
            <label>時</label>
            <select id="cmb_EndMinute" labelField="PlanCoopName" class="combo-box-required" [tabindex]="0"
              #cmb_EndMinute [(ngModel)]="kymw6501Model.endDateMI">
              <ng-template ngFor let-item [ngForOf]="kymw6501Model.endMinuteList">
                <option [value]="item">{{item}}</option>
              </ng-template>
            </select>
            <label>分</label>
          </div>

          <div></div>
          <div class="element-row" style="column-gap: 8px;">
            <label style="width: 488px;">バナーファイル名</label>
            <label>バナーキャプション</label>
          </div>

          <label class="list-input-title">開催前(BB)</label>
          <div class="list-input-content banner-items">
            <app-text-area [allowMultiLine]="false" [halfOnly]="true" id="txta_BannerFileBB_BF"
              [subid]="'txta_BannerFileBB_BF'" [maxChars]="255" verticalScrollPolicy="auto" [forcedEnabledMode]="''"
              [tabindex]="0" #txta_BannerFileBB_BF [(ngModel)]="kymw6501Model.bannerFileNameBfBB" [width]="427" [height]="60"
              (input)="eventBannerFile_deleteCommaHandler('BB_BF', 'BfBB')"
              (compositionstart)="onCompStart()" (compositionend)="onCompDeleteCommaEnd($event)">
            </app-text-area>
            <app-not-null-text-input [disabled]="false" [subid]="'txta_BannerCaptionBB_BF'"
              id="txta_BannerCaptionBB_BF" [maxChars]="50" [forcedEnabledMode]="''" [tabindex]="0"
              #txta_BannerCaptionBB_BF [useDisabledBgColor]="true" [(ngModel)]="kymw6501Model.bannerCaptionBfBB"
              [fullOnly]="true" [width]="'52rem'" [restrict]="'[ -￮]'">
            </app-not-null-text-input>
          </div>

          <label class="list-input-title">開催中(BB)</label>
          <div class="list-input-content banner-items">
            <app-text-area [allowMultiLine]="false" [halfOnly]="true" id="txta_BannerFileBB_ON"
              [subid]="'txta_BannerFileBB_ON'" [maxChars]="255" verticalScrollPolicy="auto" [forcedEnabledMode]="''"
              [tabindex]="0" [(ngModel)]="kymw6501Model.bannerFileNameOnBB" #txta_BannerFileBB_ON [width]="427" [height]="60"
              (input)="eventBannerFile_deleteCommaHandler('BB_ON', 'OnBB')"
              (compositionstart)="onCompStart()" (compositionend)="onCompDeleteCommaEnd($event)">
            </app-text-area>
            <app-not-null-text-input [disabled]="false" [subid]="'txta_BannerCaptionBB_ON'"
              id="txta_BannerCaptionBB_ON" [maxChars]="50" [forcedEnabledMode]="''" [tabindex]="0"
              #txta_BannerCaptionBB_ON [useDisabledBgColor]="true" [(ngModel)]="kymw6501Model.bannerCaptionOnBB"
              [fullOnly]="true" [width]="'52rem'" [restrict]="'[ -￮]'">
            </app-not-null-text-input>
          </div>

          <label class="list-input-title">開催後(BB)</label>
          <div class="list-input-content banner-items">
            <app-text-area [allowMultiLine]="false" [halfOnly]="true" id="txta_BannerFileBB_AF"
              [subid]="'txta_BannerFileBB_AF'" [maxChars]="255" verticalScrollPolicy="auto" [forcedEnabledMode]="''"
              [tabindex]="0" [(ngModel)]="kymw6501Model.bannerFileNameAfBB" #txta_BannerFileBB_AF [width]="427" [height]="60"
              (input)="eventBannerFile_deleteCommaHandler('BB_AF', 'AfBB')"
              (compositionstart)="onCompStart()" (compositionend)="onCompDeleteCommaEnd($event)">
            </app-text-area>
            <app-not-null-text-input [disabled]="false" [subid]="'txta_BannerCaptionBB_AF'"
              id="txta_BannerCaptionBB_AF" [maxChars]="50" [forcedEnabledMode]="''" [tabindex]="0"
              #txta_BannerCaptionBB_AF [useDisabledBgColor]="true" [(ngModel)]="kymw6501Model.bannerCaptionAfBB"
              [fullOnly]="true" [width]="'52rem'" [restrict]="'[ -￮]'">
            </app-not-null-text-input>
          </div>

          <label class="list-input-title">開催前(MB)</label>
          <div class="list-input-content banner-items">
            <app-text-area [allowMultiLine]="false" [halfOnly]="true" id="txta_BannerFileMB_BF"
              [subid]="'txta_BannerFileMB_BF'" [maxChars]="255" verticalScrollPolicy="auto" [forcedEnabledMode]="''"
              [tabindex]="0" [(ngModel)]="kymw6501Model.bannerFileNameBfMB" #txta_BannerFileMB_BF [width]="427" [height]="60"
              (input)="eventBannerFile_deleteCommaHandler('MB_BF', 'BfMB')"
              (compositionstart)="onCompStart()" (compositionend)="onCompDeleteCommaEnd($event)">
            </app-text-area>
            <app-not-null-text-input [disabled]="false" [subid]="'txta_BannerCaptionMB_BF'"
              id="txta_BannerCaptionMB_BF" [maxChars]="50" [forcedEnabledMode]="''" [tabindex]="0"
              #txta_BannerCaptionMB_BF [useDisabledBgColor]="true" [(ngModel)]="kymw6501Model.bannerCaptionBfMB"
              [fullOnly]="true" [width]="'52rem'" [restrict]="'[ -￮]'">
            </app-not-null-text-input>
          </div>

          <label class="list-input-title">開催中(MB)</label>
          <div class="list-input-content banner-items">
            <app-text-area [allowMultiLine]="false" [halfOnly]="true" id="txta_BannerFileMB_ON"
              [subid]="'txta_BannerFileMB_ON'" [maxChars]="255" verticalScrollPolicy="auto" [forcedEnabledMode]="''"
              [tabindex]="0" #txta_BannerFileMB_ON [(ngModel)]="kymw6501Model.bannerFileNameOnMB" [width]="427" [height]="60"
              (input)="eventBannerFile_deleteCommaHandler('MB_ON', 'OnMB')"
              (compositionstart)="onCompStart()" (compositionend)="onCompDeleteCommaEnd($event)">
            </app-text-area>
            <app-not-null-text-input [disabled]="false" [subid]="'txta_BannerCaptionMB_ON'"
              id="txta_BannerCaptionMB_ON" [maxChars]="50" [forcedEnabledMode]="''" [tabindex]="0"
              #txta_BannerCaptionMB_ON [useDisabledBgColor]="true" [(ngModel)]="kymw6501Model.bannerCaptionOnMB"
              [fullOnly]="true" [width]="'52rem'" [restrict]="'[ -￮]'">
            </app-not-null-text-input>
          </div>

          <label class="list-input-title">開催後(MB)</label>
          <div class="list-input-content banner-items">
            <app-text-area [allowMultiLine]="false" [halfOnly]="true" id="txta_BannerFileMB_AF"
              [subid]="'txta_BannerFileMB_AF'" [maxChars]="255" verticalScrollPolicy="auto" [forcedEnabledMode]="''"
              [tabindex]="0" #txta_BannerFileMB_AF [(ngModel)]="kymw6501Model.bannerFileNameAfMB" [width]="427" [height]="60"
              (input)="eventBannerFile_deleteCommaHandler('MB_AF', 'AfMB')"
              (compositionstart)="onCompStart()" (compositionend)="onCompDeleteCommaEnd($event)">
            </app-text-area>
            <app-not-null-text-input [disabled]="false" [subid]="'txta_BannerCaptionMB_AF'"
              id="txta_BannerCaptionMB_AF" [maxChars]="50" [forcedEnabledMode]="''" [tabindex]="0"
              #txta_BannerCaptionMB_AF [useDisabledBgColor]="true" [(ngModel)]="kymw6501Model.bannerCaptionAfMB"
              [fullOnly]="true" [width]="'52rem'" [restrict]="'[ -￮]'">
            </app-not-null-text-input>
          </div>

          <label class="list-input-title">開催前(SP)</label>
          <div class="list-input-content banner-items">
            <app-text-area [allowMultiLine]="false" [halfOnly]="true" id="txta_BannerFileSP_BF"
              [subid]="'txta_BannerFileSP_BF'" [maxChars]="255" verticalScrollPolicy="auto" [forcedEnabledMode]="''"
              [tabindex]="0" #txta_BannerFileSP_BF [(ngModel)]="kymw6501Model.bannerFileNameBfSP" [width]="427" [height]="60"
              (input)="eventBannerFile_deleteCommaHandler('SP_BF', 'BfSP')"
              (compositionstart)="onCompStart()" (compositionend)="onCompDeleteCommaEnd($event)">
            </app-text-area>
            <app-not-null-text-input [disabled]="false" [subid]="'txta_BannerCaptionSP_BF'"
              id="txta_BannerCaptionSP_BF" [maxChars]="50" [forcedEnabledMode]="''" [tabindex]="0"
              #txta_BannerCaptionSP_BF [useDisabledBgColor]="true" [(ngModel)]="kymw6501Model.bannerCaptionBfSP"
              [fullOnly]="true" [width]="'52rem'" [restrict]="'[ -￮]'">
            </app-not-null-text-input>
          </div>

          <label class="list-input-title">開催中(SP)</label>
          <div class="list-input-content banner-items">
            <app-text-area [allowMultiLine]="false" [halfOnly]="true" id="txta_BannerFileSP_ON"
              [subid]="'txta_BannerFileSP_ON'" [maxChars]="255" verticalScrollPolicy="auto" [forcedEnabledMode]="''"
              [tabindex]="0" #txta_BannerFileSP_ON [(ngModel)]="kymw6501Model.bannerFileNameOnSP" [width]="427" [height]="60"
              (input)="eventBannerFile_deleteCommaHandler('SP_ON', 'OnSP')"
              (compositionstart)="onCompStart()" (compositionend)="onCompDeleteCommaEnd($event)">
            </app-text-area>
            <app-not-null-text-input [disabled]="false" [subid]="'txta_BannerCaptionSP_ON'"
              id="txta_BannerCaptionSP_ON" [maxChars]="50" [forcedEnabledMode]="''" [tabindex]="0"
              #txta_BannerCaptionSP_ON [useDisabledBgColor]="true" [(ngModel)]="kymw6501Model.bannerCaptionOnSP"
              [fullOnly]="true" [width]="'52rem'" [restrict]="'[ -￮]'">
            </app-not-null-text-input>
          </div>

          <label class="list-input-title">開催後(SP)</label>
          <div class="list-input-content banner-items">
            <app-text-area [allowMultiLine]="false" [halfOnly]="true" id="txta_BannerFileSP_AF"
              [subid]="'txta_BannerFileSP_AF'" [maxChars]="255" verticalScrollPolicy="auto" [forcedEnabledMode]="''"
              [tabindex]="0" #txta_BannerFileSP_AF [(ngModel)]="kymw6501Model.bannerFileNameAfSP" [width]="427" [height]="60"
              (input)="eventBannerFile_deleteCommaHandler('SP_AF', 'AfSP')"
              (compositionstart)="onCompStart()" (compositionend)="onCompDeleteCommaEnd($event)">
            </app-text-area>
            <app-not-null-text-input [disabled]="false" [subid]="'txta_BannerCaptionSP_AF'"
              id="txta_BannerCaptionSP_AF" [maxChars]="50" [forcedEnabledMode]="''" [tabindex]="0"
              #txta_BannerCaptionSP_AF [useDisabledBgColor]="true" [(ngModel)]="kymw6501Model.bannerCaptionAfSP"
              [fullOnly]="true" [width]="'52rem'" [restrict]="'[ -￮]'">
            </app-not-null-text-input>
          </div>
        </div>
      </div>
    </td>
  </tr>

  <tfoot cdkDragHandle>
    <tr>
      <td>
        <div class="footer-buttons">
          <button id="btn_Delete" class="btn-tartiary warning" #btn_Delete (click)="eventDelete_CLICKHandler()"
            forcedEnabledMode="" [tabindex]="0">削除</button>
          <button id="btn_Update" class="btn-primary" #btn_Update (click)="eventUpdate_CLICKHandler()"
            forcedEnabledMode="" [tabindex]="0">更新</button>
        </div>
        <div class="window-title-close">
          <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
          <button [tabindex]="0" (click)="eventClose_CLICKHandler()"></button>
        </div>
      </td>
    </tr>
  </tfoot>
</table>